import { useEffect, useState } from "react";
import { Navigate, useSearchParams } from "react-router-dom";

import { useAuthStore } from "@/features/auth/store";

/** Landing page for an admin's "se som låntaker" preview link (?token=&loanerId=&name=).
 *  Sets up a session for the previewed company in THIS tab only (opened via
 *  window.open — see ImpersonateLoanerCard) and redirects straight to the lånestatus
 *  fane. Never touches whatever tab the admin's own session lives in. */
export function PreviewAsLoanerPage() {
  const [params] = useSearchParams();
  const setSession = useAuthStore((s) => s.setSession);
  const [ready, setReady] = useState(false);

  const token = params.get("token");
  const loanerId = params.get("loanerId");
  const name = params.get("name");

  useEffect(() => {
    if (!token || !loanerId) return;
    setSession(
      token,
      { id: Number(loanerId), role: "loaner", name, email: "", impersonated: true },
      "active"
    );
    setReady(true);
  }, [token, loanerId, name, setSession]);

  if (!token || !loanerId) {
    return (
      <div className="flex h-screen w-full items-center justify-center bg-[#0a2a2e] text-sm text-white/60">
        Mangler forhåndsvisnings-lenke.
      </div>
    );
  }
  if (!ready) return null;
  return <Navigate to="/laanestatus" replace />;
}
